<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <div class="page">
      <div class="img1"><img src="@/assets/代表工程/燕矶长江大桥.jpeg" alt="">
        <div class="img1title">燕矶长江大桥</div></div>
      <div class="mode">
        <div class="mode1">
          <div class="modetitle">
            <div class="gang"></div>
            <span>产品中心</span>
            <div class="gang"></div>
          </div>
          <div class="modepage">
            <div class="product-grid">
              <div class="contact" @click="$router.push('productDetail/product1')">
                <div class="conimg">
                  <img src="@/assets/产品/苯板类专用抹面砂浆封面.jpg" alt="">
                  <div class="conitem">苯板类专用抹面砂浆</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product2')">
                <div class="conimg">
                  <img src="@/assets/产品/苯板专用粘结剂封面.jpg" alt="">
                  <div class="conitem">苯板专用粘结剂</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product3')">
                <div class="conimg">
                  <img src="@/assets/产品/自保温砌筑封面.jpg" alt="">
                  <div class="conitem">自保温砌筑</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product4')">
                <div class="conimg">
                  <img src="@/assets/产品/聚苯乙烯颗粒封面.jpg" alt="">
                  <div class="conitem">聚苯乙烯颗粒</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product5')">
                <div class="conimg">
                  <img src="@/assets/产品/聚苯乙烯挤塑板封面.jpg" alt="">
                  <div class="conitem">聚苯乙烯挤塑板</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product6')">
                <div class="conimg">
                  <img src="@/assets/产品/聚苯乙烯发泡板封面.jpg" alt="">
                  <div class="conitem">聚苯乙烯发泡板</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product7')">
                <div class="conimg">
                  <img src="@/assets/产品/耐碱网格布封面.jpg" alt="">
                  <div class="conitem">耐碱网格布</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product8')">
                <div class="conimg">
                  <img src="@/assets/产品/热镀锌钢丝网封面.jpg" alt="">
                  <div class="conitem">热镀锌钢丝网</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product9')">
                <div class="conimg">
                  <img src="@/assets/产品/无机发泡轻骨料封面.jpg" alt="">
                  <div class="conitem">无机发泡轻骨料</div>
                </div>
              </div>
              <div class="contact" @click="$router.push('productDetail/product10')">
                <div class="conimg">
                  <img src="@/assets/产品/中空化微珠封面.jpg" alt="">
                  <div class="conitem">中空化微珠</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'ProductIndex',
  components: {
    TopNav, // 注册 TopNav 组件
    FootIndex
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  min-width: 1400px;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page {
  padding-top: 100px;
}

.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}
.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 每行显示4个产品 */
  gap: 20px; /* 产品之间的间距 */
  width: 50%;
  padding: 20px;
}

.contact {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
}

.conimg {
  height: 200px;
  width: 200px;
  position: relative; /* 设置为相对定位 */
  overflow: hidden; /* 隐藏超出部分 */
}

.conimg img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持比例，覆盖整个盒子 */
  object-position: center; /* 从中间开始对齐 */
}

.conitem {
  position: absolute; /* 设置为绝对定位 */
  bottom: 0; /* 放在照片底部 */
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景 */
  color: white; /* 文字颜色 */
  text-align: center; /* 文字居中 */
  padding: 10px; /* 内边距 */
  font-size: 16px;
}

/* 响应式布局：在小屏幕上调整为两列 */
@media (max-width: 768px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 在更小的屏幕上调整为一列 */
@media (max-width: 480px) {
  .product-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
